/**
 * 同意隐私协议弹窗
 */
import BaseModal from '..';
import ModelChoice from './model-choice';

const ModelChoiceModal = {
  self: null,
  show(data = {}) {
    this.self = BaseModal.show({
      ...data,
      borderRadius: 24,
      wrapClassName: 'nw-base-modal nw-base-modal-p-0',
      content: <ModelChoice {...data} onClose={() => this.close()} />,
      afterClose: () => {
        data?.onClose && data.onClose()
        this.close();
      },
    });
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null;
    }
  },
};

export default ModelChoiceModal;
